import 'babel-polyfill';
import './game-sdk';
import * as serviceWorker from './serviceWorker';
import App from './App';
import dotenv from 'dotenv';
import React from 'react';
import ReactDOM from 'react-dom';
import Phaser from 'phaser';
import { PreloadingScene } from './game/PreloadingScene';
import { CrosswordScene } from './game/CrosswordScene';
import { ErrorScene } from './game/ErrorScene';
import {BootScene} from "./game/BootScene";
import {TitleScene} from "./game/TitleScene";

const getPhaserGame = () => {
  dotenv.config();
  let audioContext;
  try {
    // @ts-ignore
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  } catch (e) {
    console.error(e);
  }
  const gameConfig: Phaser.Types.Core.GameConfig = {
    title: 'Crossword',

    type: Phaser.CANVAS,

    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 750,
      height: 1334,
      parent:
        'phaser-game'
    },
    audio: {
      context: audioContext
    },
    physics: {
      default: 'arcade',
      arcade: {
        debug: true
      }
    },

    scene: [BootScene, PreloadingScene,TitleScene, CrosswordScene, ErrorScene],

    parent: 'phaser-game',
    backgroundColor: '#000000',

    transparent: true
  };

  return new Phaser.Game(gameConfig);
};

window.game = getPhaserGame();

ReactDOM.render(<App />, document.getElementById('crossword-app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
